import { apiFetch } from "./client";

export type HealthAlert = "ok" | "warn" | "critical" | "unreachable";

export interface AgentHealthRow {
  agentId: string;
  agentName: string;
  adapterType: string;
  agentStatus: string;
  companyId: string;
  companyName: string;
  vmHost: string | null;
  diskPct: number | null;
  diskAvailMb: number | null;
  memUsedMb: number | null;
  memTotalMb: number | null;
  gatewayUp: boolean | null;
  uptimeS: number | null;
  alert: HealthAlert;
  probeError: string | null;
  collectedAt: string;
}

export interface AgentHealthList {
  agents: AgentHealthRow[];
  summary: Partial<Record<HealthAlert, number>>;
  total: number;
}

export interface HealthAction {
  id: string;
  label: string;
}

export interface VmActionResult {
  action: string;
  label: string;
  success: boolean;
  output: string;
}

export const agentHealthApi = {
  list: () => apiFetch<AgentHealthList>("/admin/agent-health"),
  actions: () => apiFetch<{ actions: HealthAction[] }>("/admin/agent-health/actions"),
  runAction: (agentId: string, action: string) =>
    apiFetch<VmActionResult>(`/admin/agents/${agentId}/vm-action`, {
      method: "POST",
      body: JSON.stringify({ action }),
    }),
};
